import axios from 'axios';
import { RS_ANVIL_API, ANVIL_TEMPLATE_ID2, CC_TEMPLATE_ID, API_PREFIX } from '../env';

const axiosInstance = axios.create({ baseURL: RS_ANVIL_API, withCredentials: true });

export default class RsAnvilApi {
  constructor(token) {
    this.token = token;
  }
  async generatePdf(payload, title, templateId = ANVIL_TEMPLATE_ID2) {
    const response = await axiosInstance.post(`preview/pdf/${templateId}`, {
      title,
      fontSize: 10,
      textColor: '#333333',
      data: payload,
    }, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response;
  }

  async generateAgreement({ payload, facilityCode, customerName, customerEmail, managerName, managerEmail, replyToEmail, leaseId }, templateId = ANVIL_TEMPLATE_ID2) {
    const response = await axiosInstance.post(`sign/pdf/v2/${templateId}`, {
      payload: {
        title: customerName,
        fontSize: 10,
        textColor: '#333333',
        data: payload,
      },
      customerEmail,
      facilityCode,
      customerName,
      managerEmail,
      managerName,
      replyToEmail,
      signer1Fields: ['customerSigner'],
      signer2Fields: ['managerSigner'],
      ...(leaseId ? { webhookURL: `${API_PREFIX}/anvil/api/public/webhook/lease/${leaseId}` } : {}),
    }, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }

  async cancelAgreement(weldDataEid, eid) {
    const response = await axiosInstance.post(`/void/document/${eid}/${weldDataEid}`, {
    }, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }

  async sendReminderToSigners(eid) {
    const response = await axiosInstance.post(`/remind/document/${eid}`, {
    }, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }


  async generateCCAgreement({ payload, name, customerId, replyToEmail }) {
    const response = await axiosInstance.post(`sign/docs/${CC_TEMPLATE_ID}/${customerId}`, {
      payload: {
        data: payload,
        title: name,
        fontSize: 10,
        textColor: '#333333',
      },
      name,
      signers: [
        {
          id: 'signer',
          name,
          email: payload.email,
          enableEmails: true,
          routingOrder: 1,
          fields: [
            { fileId: name, fieldId: 'sign' },
          ],
        },
      ],
      signerType: 'email',
      replyToEmail,
    }, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }

  async generatePreLienAndLienAgreement({ payload, name, customerId, options, templateId }) {
    const response = await axiosInstance.post(`/sign/docs/${templateId}/${customerId}`, {
      payload: {
        title: name,
        fontSize: 10,
        textColor: '#333333',
        data: payload,
      },
      name,
      signers: [
        {
          id: 'signer',
          name,
          signerType: 'embedded',
          signatureMode: 'text',
          email: payload.facilityEmail,
          enableEmails: false,
          // routingOrder: 1,
          fields: [
            { fileId: name, fieldId: ['PreLien', 'NonRenewal'].includes(options) ? 'signature' : 'managerSign' },
          ],
        },
      ],
    },
    {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    return response.data;
  }

  async getSignerEmbedUrl(signerEid, id) {
    const response = await axiosInstance.get(`generate/sign/url/${signerEid}/${id}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }

  async getSignersStatus(documentGroupEid) {
    const response = await axiosInstance.get(`signers/${documentGroupEid}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    return response.data;
  }

  async downloadAgreement(eid) {
    const response = await axiosInstance.get(`documents/download/${eid}`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });

    return response.data;
  }
}

export const defaultPayload = {
  title: 'KEO License Template',
  fontSize: 10,
  textColor: '#333333',
  data: {
    16: {
      street1: '123 Main St #234',
      city: 'San Francisco',
      state: 'CA',
      zip: '94106',
      country: 'US',
    },
    27: 'Address3',
    companyName0: 'Company Name',
    industryBusiness1: 'IndustryBusiness',
    taxId2: '897654321',
    representative3: 'Name',
    title4: 'Title',
    address5: 'Address1',
    phoneNumber8: {
      num: '5554443333',
      region: 'US',
      baseRegion: 'US',
    },
    email9: 'testy@example.com',
    name10: {
      firstName: 'Robin',
      mi: 'W',
      lastName: 'Smith',
    },
    phone11: {
      num: '5554443333',
      region: 'US',
      baseRegion: 'US',
    },
    address212: {
      street1: '123 Main St #234',
      city: 'San Francisco',
      state: 'CA',
      zip: '94106',
      country: 'US',
    },
    dateOfLicense13: '2022-11-21',
    commencementDate14: '2022-11-21',
    licenseFee15: 'License Fee',
    firstMonthLicenseFee16: 'First Month License Fee',
    damageDeposit17: 'Damage Deposit',
    initialTerm18: 'Initial Term',
    hoursOfAccess19: 'Hours of Access',
    maxOnSiteEmployees20: 'Max OnSite Employees',
    selfserviceWarehouseSpaceOfApproximately21: 'Selfservice warehouse space of approximately',
    squareFeetNumbered22: 'square feet numbered',
    privateOfficeSpaceTotalingApproximately23: 'Private office space totaling approximately',
    squareFeetNumbered224: 'square feet numbered_2',
    undefined25: 'undefined',
    parkingSpotsNumbered26: 'parking spots numbered',
    checkBox128: true,
    checkBox229: true,
    checkBox330: true,
    checkBox734: true,
    checkBox835: true,
    text1037: 'Text10',
    by49: 'By',
    by250: 'By_2',
    typedName53: {
      firstName: 'Robin',
      mi: 'W',
      lastName: 'Smith',
    },
    typedName254: {
      firstName: 'Robin',
      mi: 'W',
      lastName: 'Smith',
    },
    cast0f4c5d7042ff11eda0117d06b2abe251: true,
  },
};

export const payloadInfo = [
  {
    id: 'dateOfLicense13',
    name: 'Date of License',
    type: 'date',
    pageNum: 0,
    rect: {
      x: 395,
      y: 109,
      height: 16,
      width: 145,
    },
  },
  {
    id: 'companyName0',
    name: 'Company Name',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 65,
      y: 126,
      height: 16,
      width: 215,
    },
  },
  {
    id: 'commencementDate14',
    name: 'Commencement Date',
    type: 'date',
    pageNum: 0,
    rect: {
      x: 419,
      y: 126,
      height: 16,
      width: 125,
    },
  },
  {
    id: 'industryBusiness1',
    name: 'IndustryBusiness',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 142,
      y: 143,
      height: 16,
      width: 140,
    },
  },
  {
    id: 'taxId2',
    name: 'Tax ID',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 99,
      y: 161,
      height: 16,
      width: 180,
    },
  },
  {
    id: 'licenseFee15',
    name: 'License Fee',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 385,
      y: 163,
      height: 16,
      width: 110,
    },
  },
  {
    id: 'representative3',
    name: 'Name',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 130,
      y: 198,
      height: 16,
      width: 150,
    },
  },
  {
    id: 'firstMonthLicenseFee16',
    name: 'First Month License Fee',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 435,
      y: 198,
      height: 16,
      width: 105,
    },
  },
  {
    id: 'title4',
    name: 'Title',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 89,
      y: 215,
      height: 16,
      width: 190,
    },
  },
  {
    id: 'damageDeposit17',
    name: 'Damage Deposit',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 404,
      y: 215,
      height: 16,
      width: 140,
    },
  },
  {
    id: 'address5',
    name: 'Address1',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 103,
      y: 232,
      height: 16,
      width: 180,
    },
  },
  {
    id: '16',
    name: 'Address2',
    type: 'usAddress',
    pageNum: 0,
    rect: {
      x: 101,
      y: 250,
      height: 16,
      width: 180,
    },
  },
  {
    id: '27',
    name: 'Address3',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 101,
      y: 267,
      height: 16,
      width: 180,
    },
  },
  {
    id: 'initialTerm18',
    name: 'Initial Term',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 380,
      y: 267,
      height: 16,
      width: 115,
    },
  },
  {
    id: 'phoneNumber8',
    name: 'Phone Number',
    type: 'phone',
    pageNum: 0,
    rect: {
      x: 131,
      y: 284,
      height: 16,
      width: 150,
    },
  },
  {
    id: 'email9',
    name: 'Email',
    type: 'email',
    pageNum: 0,
    rect: {
      x: 94,
      y: 301,
      height: 16,
      width: 185,
    },
  },
  {
    id: 'hoursOfAccess19',
    name: 'Hours of Access',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 398,
      y: 319,
      height: 16,
      width: 145,
    },
  },
  {
    id: 'maxOnSiteEmployees20',
    name: 'Max OnSite Employees',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 433,
      y: 336,
      height: 16,
      width: 110,
    },
  },
  {
    id: 'name10',
    name: 'EmergencyName',
    type: 'fullName',
    pageNum: 0,
    rect: {
      x: 94,
      y: 370,
      height: 16,
      width: 185,
    },
  },
  {
    id: 'phone11',
    name: 'EmergencyPhone',
    type: 'phone',
    pageNum: 0,
    rect: {
      x: 96,
      y: 388,
      height: 16,
      width: 185,
    },
  },
  {
    id: 'address212',
    name: 'EmergencyAddress',
    type: 'usAddress',
    pageNum: 0,
    rect: {
      x: 103,
      y: 405,
      height: 16,
      width: 180,
    },
  },
  {
    id: 'checkBox128',
    name: 'Check Box1',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 64,
      y: 470,
      height: 18,
      width: 18,
    },
  },
  {
    id: 'selfserviceWarehouseSpaceOfApproximately21',
    name: 'Selfservice warehouse space of approximately',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 276,
      y: 469,
      height: 16,
      width: 45,
    },
  },
  {
    id: 'squareFeetNumbered22',
    name: 'square feet numbered',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 415,
      y: 469,
      height: 16,
      width: 130,
    },
  },
  {
    id: 'checkBox229',
    name: 'Check Box2',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 65,
      y: 495,
      height: 18,
      width: 18,
    },
  },
  {
    id: 'privateOfficeSpaceTotalingApproximately23',
    name: 'Private office space totaling approximately',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 258,
      y: 492,
      height: 16,
      width: 45,
    },
  },
  {
    id: 'squareFeetNumbered224',
    name: 'square feet numbered_2',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 397,
      y: 492,
      height: 16,
      width: 150,
    },
  },
  {
    id: 'checkBox330',
    name: 'Check Box3',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 65,
      y: 518,
      height: 18,
      width: 18,
    },
  },
  {
    id: 'undefined25',
    name: 'undefined',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 84,
      y: 516,
      height: 16,
      width: 30,
    },
  },
  {
    id: 'parkingSpotsNumbered26',
    name: 'parking spots numbered',
    type: 'shortText',
    pageNum: 0,
    rect: {
      x: 227,
      y: 516,
      height: 16,
      width: 320,
    },
  },
  {
    id: 'cast0f4c5d7042ff11eda0117d06b2abe251',
    name: 'New 1',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 121,
      y: 612,
      height: 17,
      width: 17,
    },
  },
  {
    id: 'checkBox734',
    name: 'Check Box7',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 101,
      y: 635,
      height: 18,
      width: 18,
    },
  },
  {
    id: 'checkBox835',
    name: 'Check Box8',
    type: 'checkbox',
    pageNum: 0,
    rect: {
      x: 153,
      y: 636,
      height: 18,
      width: 18,
    },
  },
  {
    id: 'text1037',
    name: 'Text10',
    type: 'shortText',
    pageNum: 1,
    rect: {
      x: 171,
      y: 680,
      height: 19,
      width: 70,
    },
  },
  {
    id: 'signature51',
    name: 'signature',
    type: 'signature',
    pageNum: 6,
    rect: {
      x: 81,
      y: 605,
      height: 23,
      width: 144,
    },
  },
  {
    id: 'signature252',
    name: 'signature_2',
    type: 'signature',
    pageNum: 6,
    rect: {
      x: 319,
      y: 605,
      height: 23,
      width: 144,
    },
  },
  {
    id: 'by49',
    name: 'By',
    type: 'shortText',
    pageNum: 6,
    rect: {
      x: 79,
      y: 647,
      height: 23,
      width: 144,
    },
  },
  {
    id: 'by250',
    name: 'By_2',
    type: 'shortText',
    pageNum: 6,
    rect: {
      x: 317,
      y: 647,
      height: 23,
      width: 144,
    },
  },
  {
    id: 'typedName53',
    name: 'typed name',
    type: 'fullName',
    pageNum: 6,
    rect: {
      x: 78,
      y: 689,
      height: 23,
      width: 144,
    },
  },
  {
    id: 'typedName254',
    name: 'typed name_2',
    type: 'fullName',
    pageNum: 6,
    rect: {
      x: 317,
      y: 689,
      height: 23,
      width: 144,
    },
  },
];



// WEBPACK FOOTER //
// ./src/api/rsAnvilApi.js